// 開示
export const VIEW_REQUEST_IS_DISCLOSE = 1;
// 非開示
export const VIEW_REQUEST_IS_NOT_DISCLOSE = 2;
